import React, { Component } from 'react';
import DemoImage from './DemoImage';
export default class NewsPanel extends Component {

  render(){
    return this.props.publicId
      ? (
        <section className="website">
          <header className="sub-heading">
            <h2>News &amp; media sites</h2>
            <p>Articles on your website need to be available immediately for millions of users, who expect them to load very fast. With Cloudinary’s service, your images will fit any screen or device, delivered lightning fast, in optimal quality, at any scale.</p>
          </header>
          <div className="web-daily-news">
            <div className="browser-head">
              <ul className="list-inline bullets">
                <li>bullet</li>
                <li>bullet</li>
                <li>bullet</li>
              </ul>
            </div>
            <div className="holder">
              <header className="header">
                <div className="top">
                  <ul className="left list-unstyled">
                    <li className="ico-section">Sections</li>
                    <li className="ico-search">search</li>
                  </ul>
                  <ul className="right list-unstyled">
                    <li><span className="btn-blue">Log in</span></li>
                    <li><span className="icon-gear" /></li>
                  </ul>
                </div>
                <div className="bottom">
                  <div className="weather">
                    <img src="images/img030.jpg" className="hidden-sm hidden-xs" height="70" width="200" alt="weather"/>
                    <img src="images/img030-md.jpg" className="visible-sm" height="70" width="200" alt="weather"/>
                    <img src="images/img030-sm.jpg" className="visible-xs" height="43" width="100" alt="weather"/>
                  </div>
                  <div className="graph">
                    <img src="images/graph.jpg" className="hidden-sm hidden-xs" height="68" width="198" alt="weather"/>
                    <img src="images/graph-md.jpg" className="visible-sm" height="70" width="144" alt="weather"/>
                    <img src="images/graph-sm.jpg" className="visible-xs" height="43" width="100" alt="weather"/>
                  </div>
                  <div className="center">
                    <h1 className="text-center">DAILY NEWS</h1>
                    <ul className="nav">
                      <li>World</li>
                      <li>Politics</li>
                      <li>Sports</li>
                      <li>Business</li>
                      <li className="hidden-sm hidden-xs">Opinion</li>
                      <li className="hidden-sm hidden-xs">Tech</li>
                      <li className="hidden-sm hidden-xs">Science</li>
                      <li className="hidden-md hidden-sm hidden-xs">Lifestyle</li>
                      <li className="active text-uppercase">All</li>
                    </ul>
                  </div>
                </div>
              </header>
              <div className="top-block">
                <DemoImage {...this.props} transformation={[{crop: 'fill', aspect_ratio: '600:429', width: 'auto', gravity: 'faces'}, {effect: 'gradient_fade', background: '#00000099', y: -0.4},
                  {overlay: 'text:Times_24_bold_italic:Breaking%20news:%20Cloudinary%20solves%20all%20your%20image%20related%20needs', color: 'white', width: 0.9, flags: 'relative'}, {effect: 'shadow', color: 'black', x:2, y: 1},
                  {gravity: 'south_west', x: 20, y: 25, flags: 'layer_apply'}, {dpr: 'auto'}]} className="img pull-left" format="jpg">
                  <ul><li>Crop and resize the image to optimally fit the required dimensions</li><li>Focus on auto-detected faces</li><li>Add a dynamic text overlay over a fading black gradient</li></ul>
                </DemoImage>
                <div className="article-list">
                  <article className="article">
                    <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'thumb', width: 200, height: 133, gravity: 'face'}} className="img" format="jpg">
                      <p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected face</li><li>Crop and resize the image</li></ul>
                    </DemoImage>
                    <div className="desc">
                      <h2>Face Thumbnail</h2>
                      <p>Dynamically create a perfect thumbnail based on automatically detected faces and zoom in for focus.</p>
                    </div>
                  </article>
                  <article className="article">
                    <DemoImage {...this.props} transformation={[{dpr: 'auto', crop: 'fill', width: 200, height: 133, gravity: 'auto:50'}, {overlay: 'cloudinary_icon', x: 5, y: 5, gravity: 'north_east', color: 'white', effect: 'colorize', opacity: 50, width: 0.5, flags: ['relative']}]} className="img" format="jpg">
                      <p>Add a watermark on-the-fly.</p>
                      <ul>
                        <li>Overlay an existing image already uploaded to Cloudinary, in this case the Cloudinary logo</li>
                        <li>Adjust its width and place it in the north-east corner</li>
                        <li>Set its opacity to 50%</li>
                      </ul>
                    </DemoImage>
                    <div className="desc">
                      <h2>Add a Watermark</h2>
                      <p>Add a watermark of your company logo or any other image, and insert it wherever you choose.</p>
                    </div>
                  </article>
                  <article className="article hidden-xs">
                    <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'fill', width: 200, height: 133, gravity: 'faces', effect: 'pixelate_faces'}} className="img" format="jpg">
                      <p>Pixelate auto-detected faces and crop the image to fit the relevant size.</p>
                    </DemoImage>
                    <div className="desc">
                      <h2>Pixelate Faces</h2>
                      <p>Easily anonymize your photos to keep privacy by pixelating auto-detected faces.</p>
                    </div>
                  </article>
                </div>
              </div>
              <div className="three-col">
                <div className="col">
                  <h2>Sports</h2>
                  <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'fill', gravity: 'faces', effect: 'sharpen:200', width: 290, height: 150}} className="img bg-cover" format="jpg">
                    <ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected faces</li><li>Sharpen the image</li></ul>
                  </DemoImage>
                </div>
                <div className="col hidden-xs">
                  <h2>Politics</h2>
                  <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'fill', gravity: 'auto', width: 290, height: 150}} className="img bg-cover" format="jpg">
                    <ul><li>Resize and crop the image to fit graphic design</li><li>Focus on auto-detected area of interest</li></ul>
                  </DemoImage>
                </div>
                <div className="col">
                  <h2>Culture</h2>
                  <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'fill', gravity: 'faces', effect: 'saturation:50', width: 400, height: 150}} className="img bg-cover" format="jpg">
                    <ul><li>Resize and crop the image to the relevant size</li><li>Focus on automatically detected faces</li><li>Add more saturation</li></ul>
                  </DemoImage>
                </div>
              </div>
            </div>
          </div>
        </section>
      )
      : null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/NewsPanel.js
 **/